import { render } from "./profession-list-modal.vue?vue&type=template&id=1571be29"
import script from "./profession-list-modal.vue?vue&type=script&lang=js"
export * from "./profession-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__